import React from 'react'
import {compose, lifecycle, withState} from 'recompose'
import Swiper from 'swiper/dist/js/swiper.js';
import 'swiper/dist/css/swiper.min.css'
import One from './one'
import Two from './two'
import Many from './many'

function ImageList({list, guid, style}) {
  return (
    <div
      className='image-list'
      style={{
        flexGrow: 1,
        maxWidth: 592,
        ...(!list || list.length == 0) && {display: 'none'},
        ...(style && style),
      }}
    >
      {
        list && list.length == 1 && <One list={list}/>
      }
      {
        list && list.length == 2 && <Two list={list}/>
      }
      {
        list && list.length > 2 && <div style={{maxWidth: 450}}><Many list={list}/></div>
      }
    </div>
  )
}

export default compose(
  withState('guid', 'setGuid', ''),
  lifecycle({
    componentDidMount() {
      function genGuid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }

        return 'x' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      }

      const guid = genGuid();
      this.props.setGuid(guid)
      const list = this.props.list
      setTimeout(() => {
        new Swiper(`.${guid} .swiper-container`, {
          loop: true,
          keyboardControl: true,
          autoplay: 6000,
          autoplayDisableOnInteraction: false,
          speed: 1000,
          pagination: {
            el: `.${guid} .swiper-pagination-thumb`,
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '" style="display: inline-block; background: transparent; width: auto; height: auto"><img src="' + list[index] + '" style="max-width:80px; max-height: 80px; margin-right:10px"></span>';
            },
          },
          spaceBetween: 10
        })
      }, 0)
    }
  })
)
(ImageList)



// WEBPACK FOOTER //
// ./src/finwhale/common/item/image-list/index.js